// Import SWISSM JSON config files at build time (10 modules only)
import accoConfig from './modules/acco.json';
import adminConfig from './modules/admin.json';
import bunkConfig from './modules/bunk.json';
import charteringConfig from './modules/chartering.json';
import commConfig from './modules/comm.json';
import freiConfig from './modules/frei.json';
import mapConfig from './modules/map.json';
import mdConfig from './modules/md.json';
import operConfig from './modules/oper.json';
import pdaConfig from './modules/pda.json';
import type { ModuleConfig } from './types';

// Merge SWISSM module configs into a single array
// Order matches the priority: MD, ACCO, CHARTERING, OPER, BUNK, PDA, FREI, MAP, COMM, ADMIN
export const legacyMenuConfigs: ModuleConfig[] = [
  ...mdConfig,
  ...accoConfig,
  ...charteringConfig,
  ...operConfig,
  ...bunkConfig,
  ...pdaConfig,
  ...freiConfig,
  ...mapConfig,
  ...commConfig,
  ...adminConfig
];
